import { render, staticRenderFns } from "./detailIngameHole.vue?vue&type=template&id=727dcd3c&scoped=true"
import script from "./detailIngameHole.vue?vue&type=script&lang=js"
export * from "./detailIngameHole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727dcd3c",
  null
  
)

export default component.exports